import { HeaderFieldCellMixins, HeaderRangeFieldCellMixins } from './mixins.js';

const number_header_cell_comp = {
  mixins: [HeaderFieldCellMixins, HeaderRangeFieldCellMixins],

  template: `
    <div class="filter-field-popover">
      <div class="filter-params-container">
        <div class="form-control">
          <div class="form-control-label">最小</div>
          <div class="input-control">
            <input class="controlled-input bordered"
                   type='number'
                   :value='start'
                   @change.lazy='updateStartValue'
                   placeholder='请输入' />
          </div>
        </div>
        <div class="form-control">
          <div class="form-control-label">最大</div>
          <div class="input-control">
            <input class="controlled-input bordered"
                   type='number'
                   :value='end'
                   @change.lazy='updateEndValue'
                   placeholder='请输入' />
          </div>
        </div>
      </div>
      <div class="sort-option-container list">
        <div class="list-item"
             v-for="sort in sortable"
             @click='toggleSort(sort)'
             :key='sort'>
          <div class="content">{{ Skylark.Helpers.getZH_CN('sort.' + sort) }}排列</div>
          <div class="tip" v-if='sorter === sort'>
            <i class="slp-check"></i>
          </div>
        </div>
      </div>
    </div>
  `,

  methods: {
    updateStartValue: function(event) {
      this.updateStart(event.target.value);
    },

    updateEndValue: function(event) {
      this.updateEnd(event.target.value);
    }
  }
};

export {
  number_header_cell_comp as IntegerHeaderCell,
  number_header_cell_comp as RatingHeaderCell
};
